import React from 'react'
import { LatLng } from 'leaflet'
import { MapContainer, TileLayer, Marker } from 'react-leaflet'
import { useTranslation } from 'react-i18next'
import { Flex, Text } from '@aws-amplify/ui-react'

interface PlaceOverviewMapProps {
    placePosition: LatLng
    isLoggedIn: boolean
}

const PlaceOverviewMap: React.FC<PlaceOverviewMapProps> = ({ placePosition, isLoggedIn }) => {

    const DEFAULT_ZOOM_LEVEL: number = 17;
    
    const { t } = useTranslation();

    // For non-logged in users, show center of New York at max zoom
    const displayPosition = isLoggedIn ? placePosition : new LatLng(40.7128, -74.0060); // NYC center

    return (
        <div className="place-overview-map-container">
            <MapContainer
                center={[displayPosition.lat, displayPosition.lng]}
                zoom={DEFAULT_ZOOM_LEVEL}
                // scrollWheelZoom={isLoggedIn}
                scrollWheelZoom={false}
                attributionControl={false}
                zoomControl={isLoggedIn}
                dragging={isLoggedIn}
                touchZoom={isLoggedIn}
                // touchZoom={false}
                doubleClickZoom={isLoggedIn}
                boxZoom={isLoggedIn}
                keyboard={isLoggedIn}
            >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {isLoggedIn && (
                    <Marker 
                        position={[placePosition.lat, placePosition.lng]}
                        interactive={false}
                    />
                )}
            </MapContainer>
            {!isLoggedIn && (
                <div className="place-overview-map-overlay">
                    <Flex
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                        gap="small"
                        className="place-overview-map-overlay-content"
                    >
                        <Text className="place-overview-map-overlay-text">
                            {t('place.overview.map.login-to-see')}
                        </Text>
                    </Flex>
                </div>
            )}
        </div>
    )
}

export default PlaceOverviewMap;
